module.exports = __webpack_public_path__ + "static/media/textile_print_02.a24ffd9c.jpg";